import { Component, OnDestroy, OnInit } from '@angular/core';
import { BehaviorSubject } from "rxjs";
import { ProjectGroup } from "../shared/interfaces/project-group.interface";
import { ProjectRouteStation } from "../shared/interfaces/project-route-station.interface";
import { ProjectDataService } from "../shared/services/project-data.service";
import { SchemaLine, SchemaLineWithPosition } from './shared/interfaces/schema-line.class';
import { ProjectRouteStationWithParam } from "../shared/interfaces/project-route-station.class";
import { MatDialog } from "@angular/material/dialog";
import { SchemaAddStationModalComponent } from "./schema-add-station-modal/schema-add-station-modal.component";
import { RouteStationService } from "../shared/services/route-station.service";
import { CdkDragDrop } from "@angular/cdk/drag-drop";
import { SchemaRouteStationModalComponent } from "./schema-route-station-modal/schema-route-station-modal.component";
import { ProjectImageData } from "../shared/interfaces/project-image-data.interface";
import { ImageDataService } from "../shared/services/image-data.service";
import { DataPointService } from '../shared/services/datapoint.service';
import { GroupService } from '../shared/services/group.service';
import { TrafficLanes } from './shared/interfaces/trafficLanes.interface';
import { Router } from '@angular/router';
import { RadarDataChartComponent } from './shared/components/radar-data-chart/radar-data-chart.component';
import { DeviceService } from 'src/app/device/shared/services/device.service';
import { AlertService } from 'src/app/shared/alert/shared/alert.service';
import { AlertTypes } from 'src/app/shared/alert/shared/alert-types';
import { Subscription } from 'rxjs';
import { ProjectGroupMetaInformation } from '../shared/interfaces/project-group-meta-information';
import { ScenarioService } from '../shared/services/scenario.service';
import { Scenario } from '../shared/interfaces/scenario.interface';
import { ScenarioSelectDialogComponent } from './scenario-select-dialog/scenario-select-dialog.component';
import { UserDataService } from 'src/app/user/shared/services/user-data.service';
import { SWAConfig } from '../shared/interfaces/swaconfig';
import * as _ from 'lodash';
import { CameraViewModalComponent } from './shared/components/camera-view-modal/camera-view-modal.component';
import { getCameraType } from '../shared/enums/camera-type.enum';
import { mapSchemaRadarToChartRadar } from '../shared/functions/schema-radar-mapper';
import { Radar } from 'src/app/device/shared/interfaces/radar.interface';

import cloneDeep from 'lodash/cloneDeep';

@Component({
  selector: 'avs-project-schema',
  templateUrl: './project-schema.component.html',
  styleUrls: ['./project-schema.component.css']
})
export class ProjectSchemaComponent implements OnInit, OnDestroy {
  public activeRouteStation: ProjectRouteStation | undefined;
  public routeStations: ProjectRouteStation[] | undefined;
  public activeGroup: ProjectGroup | undefined;
  public projectRouteStations: ProjectRouteStationWithParam[] | undefined;
  public activeScenario: Scenario | undefined;
  public settings?: string;
  public formattedJson: any;
  public matchingSWAConfig?: SWAConfig;

  public isJsonValid?: boolean
  public validJson: any;
  public line: SchemaLine = new SchemaLine(
    [{ station: undefined, x: 1, isActive: false, line: [], colorArr: [] }, { station: undefined, x: 2, isActive: false, line: [], colorArr: [] }, { station: undefined, x: 3, isActive: false, line: [], colorArr: [] }, /* schema line erweitern um piktogram? */
    { station: undefined, x: 4, isActive: false, line: [], colorArr: [] }, { station: undefined, x: 5, isActive: false, line: [], colorArr: [] }, { station: undefined, x: 6, isActive: false, line: [], colorArr: [] },
    { station: undefined, x: 7, isActive: false, line: [], colorArr: [] }, { station: undefined, x: 8, isActive: false, line: [], colorArr: [] }, { station: undefined, x: 9, isActive: false, line: [], colorArr: [] },
    { station: undefined, x: 10, isActive: false, line: [], colorArr: [] }, { station: undefined, x: 11, isActive: false, line: [], colorArr: [] }, { station: undefined, x: 12, isActive: false, line: [], colorArr: [] },
    { station: undefined, x: 13, isActive: false, line: [], colorArr: [] }, { station: undefined, x: 14, isActive: false, line: [], colorArr: [] }, { station: undefined, x: 15, isActive: false, line: [], colorArr: [] },
    { station: undefined, x: 16, isActive: false, line: [], colorArr: [] }, { station: undefined, x: 17, isActive: false, line: [], colorArr: [] }, { station: undefined, x: 18, isActive: false, line: [], colorArr: [] },
    { station: undefined, x: 19, isActive: false, line: [], colorArr: [] }, { station: undefined, x: 20, isActive: false, line: [], colorArr: [] }, { station: undefined, x: 21, isActive: false, line: [], colorArr: [] },
    { station: undefined, x: 22, isActive: false, line: [], colorArr: [] }, { station: undefined, x: 23, isActive: false, line: [], colorArr: [] }, { station: undefined, x: 24, isActive: false, line: [], colorArr: [] },
    { station: undefined, x: 25, isActive: false, line: [], colorArr: [] }
  ],

    [{ station: undefined, x: 1, isActive: false, line: [], colorArr: [] }, { station: undefined, x: 2, isActive: false, line: [], colorArr: [] }, { station: undefined, x: 3, isActive: false, line: [], colorArr: [] },
    { station: undefined, x: 4, isActive: false, line: [], colorArr: [] }, { station: undefined, x: 5, isActive: false, line: [], colorArr: [] }, { station: undefined, x: 6, isActive: false, line: [], colorArr: [] },
    { station: undefined, x: 7, isActive: false, line: [], colorArr: [] }, { station: undefined, x: 8, isActive: false, line: [], colorArr: [] }, { station: undefined, x: 9, isActive: false, line: [], colorArr: [] },
    { station: undefined, x: 10, isActive: false, line: [], colorArr: [] }, { station: undefined, x: 11, isActive: false, line: [], colorArr: [] }, { station: undefined, x: 12, isActive: false, line: [], colorArr: [] },
    { station: undefined, x: 13, isActive: false, line: [], colorArr: [] }, { station: undefined, x: 14, isActive: false, line: [], colorArr: [] }, { station: undefined, x: 15, isActive: false, line: [], colorArr: [] },
    { station: undefined, x: 16, isActive: false, line: [], colorArr: [] }, { station: undefined, x: 17, isActive: false, line: [], colorArr: [] }, { station: undefined, x: 18, isActive: false, line: [], colorArr: [] },
    { station: undefined, x: 19, isActive: false, line: [], colorArr: [] }, { station: undefined, x: 20, isActive: false, line: [], colorArr: [] }, { station: undefined, x: 21, isActive: false, line: [], colorArr: [] },
    { station: undefined, x: 22, isActive: false, line: [], colorArr: [] }, { station: undefined, x: 23, isActive: false, line: [], colorArr: [] }, { station: undefined, x: 24, isActive: false, line: [], colorArr: [] },
    { station: undefined, x: 25, isActive: false, line: [], colorArr: [] }
   ]);

  public unassignedStations: ProjectRouteStationWithParam[] = [];
  public width: number[] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
  public countdown: number = 30;
  public isGroupChanged: boolean = false;
  public freewayLanes: TrafficLanes[] = [];
  public isEditSchemaActive: boolean = false;
  public isCompletelyLoaded: boolean = false;
  public projectImages: ProjectImageData[] = [];
  public trafficSignPosition: number = -36;
  public isAreaACollapsed: boolean = true;
  public isAreaBCollapsed: boolean = true;
  public timer: any;
  public scenarios: Scenario[] = [];
  public schemaSubscriptionCollection: Subscription[] = [];
  public activeRouteStationSubscription?: Subscription;
  public activeGroupSubscription?: Subscription;
  public projectRouteStationsWithParamSubscription?: Subscription;
  public projectImagesSubscription?: Subscription;
  public schemaMetaInformationSubscription?: Subscription;
  public schemaScenariosSubscription?: Subscription;

  private openDialogs = new Set<number>();
  public groupHasCamera: boolean = false;
  public groupHasRecordings: boolean = false;
  public groupHasBarrier: boolean = false;

  public isRadarDialogOpenForX: number = 0;
  private radarData$ = new BehaviorSubject<Radar[]>([]);

  constructor(private projectDataService: ProjectDataService,
    private dialog: MatDialog,
    private stationService: RouteStationService,
    private readonly imageDataService: ImageDataService,
    private dataPointService: DataPointService,
    private groupService: GroupService,
    private router: Router,
    private deviceService: DeviceService,
    private alertService: AlertService,
    private scenarioService: ScenarioService,
    private userDataService: UserDataService

  ) {
    this.schemaMetaInformationSubscription = projectDataService.schemaMetaInformation.subscribe(metaInfo => {
      if (this.activeGroup) this.activeGroup.metaInformation = metaInfo;
    });
    this.schemaScenariosSubscription = projectDataService.schemaScenarios.subscribe(scenarios => {
      if (this.userDataService.isAdmin() || this.userDataService.isUser()) {
        this.scenarios = scenarios;
        this.activeScenario = scenarios.find((x: Scenario) => x.enabled === true);
      }
    });
    this.activeRouteStationSubscription = projectDataService.activeRouteStation.subscribe(routeStation => {
      this.activeRouteStation = routeStation; /* Warum wird hier eine einzelne routeStation gezogen? */
    });
    this.activeGroupSubscription = projectDataService.activeGroup.subscribe(group => {
      if (group) {
        this.setTrafficLanesFromActiveGroup(group);
        if (group !== this.activeGroup) {
          this.isGroupChanged = true;
          this.countdown = 30;
        }
        // Meta-Informationen und Szenarien kommen gebündelt mit dem Schema-Endpunkt
        // (siehe Subscriptions im Konstruktor), keine separaten Requests mehr
        this.activeGroup = group;
      }
      else{
        this.activeGroup = group;
      }
    });


    this.projectRouteStationsWithParamSubscription = projectDataService.projectsRouteStationsWithParam.subscribe(routeStations => {
      this.projectRouteStations = routeStations;

      if (routeStations) {
        this.fillLineWithStations(routeStations);

        this.checkForCamera(routeStations)

        this.checkRadarDialogData(routeStations);
      }
    });

    this.projectImagesSubscription = imageDataService.projectImages.subscribe(images => {
      this.projectImages = images;
      this.rotateImagesPaths(this.projectImages);
    });

  }

  public ngOnInit(): void {
    this.startTimer();
    this.schemaSubscriptionCollection.push(this.activeRouteStationSubscription!);
    this.schemaSubscriptionCollection.push(this.activeGroupSubscription!);
    this.schemaSubscriptionCollection.push(this.projectRouteStationsWithParamSubscription!);
    this.schemaSubscriptionCollection.push(this.projectImagesSubscription!);
    this.schemaSubscriptionCollection.push(this.schemaMetaInformationSubscription!);
    this.schemaSubscriptionCollection.push(this.schemaScenariosSubscription!);
  }

  public ngOnDestroy(): void {
    this.stopTimer()
    this.schemaSubscriptionCollection.forEach(sub => sub.unsubscribe());
    this.dialog.closeAll();

  }
  public rotateImagesPaths(images: ProjectImageData[]): void {
    if (images === null || images === undefined) return;
    images.forEach(image => {
      if (image.isAnimated && image.animatedImageIds!.length > 0) { /* für jedes Bild, das für die RouteStation gesetzt wird, wird nun separat geprüft ob ein animatedImageId vorhanden ist */
        this.rotatePathForId(image)
      }
    });
  }



  public rotatePathForId(image: ProjectImageData): void {
    const myValueList = image.animatedImageIds!;

    let i = 0;
    const id = setInterval(() => {
      image.path = this.getPathByImageId(myValueList[i++]); /* iteration durchs animatedimage array, und zieht sich dasnn über die id, den path */
      if (i === myValueList.length) {
        i = 0;
      }
    }, 1000);
  }

  public getPathByImageId(imageId: number) {

    if (this.projectImages) {
      let imageObject = this.projectImages.find((x) => x.imageId == imageId)
      return imageObject?.path as string
    }
    else return
  }

  private checkForCamera(routeStations: ProjectRouteStationWithParam[]): void {
    this.groupHasCamera = false;
    this.groupHasRecordings = false;
    this.groupHasBarrier = false;
    routeStations.forEach(routeStation => {
      this.groupHasBarrier = this.groupHasBarrier || (routeStation.schemaInfo?.barrier != undefined);
      this.groupHasCamera = this.groupHasCamera || (routeStation.schemaInfo?.deviceType == 5 || routeStation.schemaInfo?.deviceType == 6);
      this.groupHasRecordings = this.groupHasRecordings || routeStation.schemaInfo?.deviceType == 5;
    });
  }
  
  private checkRadarDialogData(routeStations: ProjectRouteStationWithParam[]) {
    if (this.isRadarDialogOpenForX > 0)
    {
      var updatesRadars = this.determineRadarData(this.isRadarDialogOpenForX);
      this.radarData$.next(updatesRadars);
    }
  }
  
  public colorRoadByZ(routeStations: ProjectRouteStationWithParam[]): void {
    this.settings = '';
    this.formattedJson = '';
    this.validJson = '';
    this.isJsonValid = undefined;
    this.matchingSWAConfig = undefined;
    if (this.activeGroup) {
      
    routeStations.forEach(rs => {
      if (rs.schemaInfo?.radars && rs.schemaInfo.radars.length > 0) {
        rs.schemaInfo.radars.filter(r => r.data != null).forEach(r => {
            let coordinates = { 
              x: rs.routeStation.x, 
              y: rs.routeStation.y, 
              samId: rs.routeStation.samId, 
              z: r.data!.mqResult ? r.data!.mqResult.z : 0, 
              line: r.cInfo.channel.de}; //By now determine line from channel, ignore radar data line parameter for now!!!!
            this.setColors(coordinates) 
        });
      }

    })
       
     /*this.MQResultService.getMQResultByGroupId(this.activeGroup!.id).subscribe(MQResult => { 
        this.MQResults = MQResult; 
        if (this.MQResults) { 
          this.MQResults.forEach(x => { 
            if (x.saM_Id) 
              this.getCoordinates(x) 
            }) 
        } 
      })*/
    }
  }

  /*private getCoordinates(MQResult: MQResult): void {
    this.projectRouteStations?.forEach(x => { 
      if (MQResult.saM_Id === x.routeStation.samId) { 
        let coordinates = { x: x.routeStation.x, y: x.routeStation.y, samId: MQResult.saM_Id, z: MQResult.z, line: MQResult.channel}; //By now line by channel
        console.log ("going to set colors from getCoordinates setColors", coordinates);
        this.setColors(coordinates) 
      } 
    })
  }*/
 
  public setColors(coordinates: any): void {
    let colorX = coordinates.x;
    let colorZ = coordinates.z
    let line = coordinates.line
    this.line.areaA.forEach(element => {
      if (line && element.x === colorX) {
          element.colorArr[this.freewayLanes.length - line] = this.chooseColor(colorZ); 
          element.line.push(line)
      }
    });
    this.line.areaB.forEach(element => {
      if (line && element.x === colorX) { 
        element.colorArr[this.freewayLanes.length - line] = this.chooseColor(colorZ);
        element.line.push(line)
       }
    });
  }

  private chooseColor(colorZ: any) {
    switch (colorZ) {
      case 4:
        return 'avs-red';
      case 3:
        return 'avs-orange';
      case 2:
        return 'avs-yellow';
      case 1:
        return 'avs-green';
      default:
        return ''
    }
  }

  public onEditSchemaBtnChanged(): void {
    this.isEditSchemaActive = !this.isEditSchemaActive;

    if (!this.isEditSchemaActive) {

      this.onCollapseSchemeClicked();

    } else {
      this.stopTimer();
      if (!this.line.areaA[0].isActive && !this.line.areaB[0].isActive) {

        this.onExpandSchemeClicked();
      } else {
        if (!this.projectRouteStations) { return; }
        let stations = this.projectRouteStations.sort(
          (a, b) => b.routeStation.x - a.routeStation.x);
        if (!stations[0]) { return; }
        for (let area of this.line.areaA) {
          if (area.x <= stations[0].routeStation.x) {
            area.isActive = true;
          }
        }
        for (let area of this.line.areaB) {
          if (area.x <= stations[0].routeStation.x) {
            area.isActive = true;
          }
        }
      }
    }
  }

  public onSzenarioSelectClicked(): void {
    this.dialog.open(ScenarioSelectDialogComponent, { data: { scenarios: this.scenarios, groupId: this.activeGroup?.id! } }).afterClosed().subscribe(result => {
      if (result === undefined) return;
      if (result.result === 'changed') {
        setTimeout(() => {
          this.getGroupsScenarios(this.activeGroup!.id);
        }, 500);
        this.alertService.alert("Sonderprogramm wurde erfolgreich geändert", AlertTypes.success);
        this.countdown = 5;
      }
    });
  }

  public getGroupsScenarios(groupId: number): void {
    let hasPermission = false;
    if (this.userDataService.isAdmin() || this.userDataService.isUser()) hasPermission = true;

    if (hasPermission) {
      this.scenarioService.getAllScenariosByGroupId(groupId).subscribe(scenarios => { this.scenarios = scenarios; this.activeScenario = scenarios.find((x: Scenario) => x.enabled === true) }
      );
    }
    else return
  }

  public onAddBtnClicked(x: number, y: number): void {
    const dialogRef = this.dialog.open(SchemaAddStationModalComponent, { data: this.unassignedStations });
    dialogRef.afterClosed().subscribe((station: ProjectRouteStationWithParam) => {
      if (station) {
        station.routeStation.x = x;
        station.routeStation.y = y;
        station.routeStation.z = this.checkForZ(x, y)


        this.stationService.editProjectRouteStation(station.routeStation.id, station.routeStation).subscribe(() => {
          this.projectDataService.updateActiveGroup(this.activeGroup);
        });
      }
    });
  }

  isIo7(station: ProjectRouteStationWithParam): string {
    // Auswertung aller ios mit type === 8, wenn einer aktiv dann active, wenn keiner aktiv aber mindestens einer inaktiv dann inactive, wenn keiner vorhanden dann not found
    let statusMissing = false;
    for (const io of station.schemaInfo?.digitalIOs ?? []) {
      if (io.cInfo.channel.deType === 8) {
        if (io.data?.activeStatus === true) {
          return 'active';
        } else if (io.data?.activeStatus === false) {
          return 'inactive';
        } else {
          statusMissing = true;
        }
      }
    }
    return statusMissing ? 'statusNotFound' : 'notFound';
  }

  diTooltip(station: ProjectRouteStationWithParam): string {
    let activeIOsNumberArray: number[] = [];
    let inactiveIOsNumberArray: number[] = [];
    let notFoundIOsNumberArray: number[] = [];
    let type7Count = 0;
    // Auswertung aller ios mit type === 7, dann nach status.active sortieren, wenn status.active nicht vorhanden dann status nicht gefunden ohne auf de kanäle zu achten#
    const digitalIOs = station.schemaInfo?.digitalIOs ?? [];
    if (digitalIOs.length > 0) {
      for (const io of digitalIOs) {
        if (io.cInfo.channel.deType === 7) {
          type7Count++
          if (io.data?.diResult != null) {
            if (io.data.diResult.active === true) {
              activeIOsNumberArray.push(io.cInfo.channel.de);
            } else if (io.data.diResult.active === false) {
              inactiveIOsNumberArray.push(io.cInfo.channel.de);
            }
          } else {
            notFoundIOsNumberArray.push(io.cInfo.channel.de);
          }
        }

      }
      let tooltip = 'DI Status:\n';
      if (activeIOsNumberArray.length > 0) {
        tooltip += `Aktive DI Kanäle: ${activeIOsNumberArray.join(', ')}\n`;
      }
      if (inactiveIOsNumberArray.length > 0) {
        tooltip += `Inaktive DI Kanäle: ${inactiveIOsNumberArray.join(', ')}\n`;
      }
      if (notFoundIOsNumberArray.length > 0) {
        tooltip += `DI Kanäle ohne Status: ${notFoundIOsNumberArray.join(', ')}\n`;
      }
      if (type7Count === 0) {
        return 'Keine DI Kanäle vorhanden';
      }
      return tooltip;
    }
    return 'Keine DI Kanäle vorhanden';
  }


  diColor(station: ProjectRouteStationWithParam): string {
    // Auswertung aller ios mit type 7 wenn alle not found, if one active, return green (highest priority), if none is active (but at least one is inactive return black) and if nonefound return gray
    let hasType7 = false;
    let hasActive = false;
    let hasInactive = false;
    for (const io of station.schemaInfo?.digitalIOs ?? []) {
      if (io.cInfo.channel.deType === 7) {
        hasType7 = true;
        if (io.data?.diResult != null) {
          if (io.data.diResult.active === true) {
            hasActive = true;
          } else if (io.data.diResult.active === false) {
            hasInactive = true;
          }
        }
      }
    }
    if (hasType7) {
      if (hasActive) {
        return 'green';
      } else if (hasInactive) {
        return 'black';
      } else {
        return 'gray';
      }
    }

    return 'gray'; // Fallback-Farbe
  }


  public checkForZ(x: number, y: number): number {
    if (y === 1) {
      let coordinate = this.line.areaA.find(areaA => areaA.x === x)
      let stations = coordinate?.station
      if (stations?.length === 0 || stations === undefined) {
        return 1
      }
      else {
        let gap = this.findFreeId(stations!)
        if (gap === 0) {
          return stations.length + 1
        }
        else {
          return gap
        }
      }
    }
    else if (y === 2) {
      let coordinate = this.line.areaB.find(areaB => areaB.x === x)
      let stations = coordinate?.station
      if (stations?.length === 0 || stations === undefined) {
        return 1
      }
      else {
        let gap = this.findFreeId(stations!)
        if (gap === 0) {
          return stations.length + 1
        }
        else {
          return gap
        }
      }
    }
    return 0
  }
  private isRouteStationDialogOpen = false;

  public onStationClicked(station: ProjectRouteStationWithParam): void {
    const cams = station.schemaInfo?.cameras;
    const isCamera = Array.isArray(cams) &&
      (cams[0]?.camType === 18 || cams[0]?.camType === 19);

    if (!isCamera) {
      // Nur ein SchemaRouteStationModalComponent gleichzeitig
      if (this.isRouteStationDialogOpen) {
        return;
      }
      this.isRouteStationDialogOpen = true;

      this.projectDataService.updateActiveRouteStation(station.routeStation);
      this.countdown = 5;
      this.dialog.open(SchemaRouteStationModalComponent, {
        data: cloneDeep(station),
        maxHeight: '98vh',
        hasBackdrop: false,
        panelClass: 'draggable-resizable-dialog'
      }).afterClosed().subscribe(result => {
        this.isRouteStationDialogOpen = false;
        this.countdown = 5;
        this.projectDataService.updateActiveGroup(this.activeGroup);
        if (result?.toDelete) {
          this.deleteStationFromSchema(result.data);
        }
        if (result?.navigate) {
          this.navigateToRouteStation(station);
        }
      });

    } else {
      // Kamera-Dialogs beliebig oft
      this.dialog.open(CameraViewModalComponent, {
        data: {
          name: station.routeStation.name,
          rs: station.routeStation.id,
          type: (station.schemaInfo?.cameras && station.schemaInfo.cameras.length > 0 && station.schemaInfo.cameras[0].camType != null) ? getCameraType(station.schemaInfo.cameras[0].camType) : undefined
        },
        hasBackdrop: false,
        panelClass: 'draggable-resizable-dialog'
      }).afterClosed().subscribe(result => {
        if (result) {
          // Handle camera result
        }
      });
    }
  }

  onStationInfoClicked(station: ProjectRouteStationWithParam): void {
    this.dialog.open(SchemaRouteStationModalComponent, {
      data: station
    });
  }

  openCamera(station: ProjectRouteStationWithParam): void {
    const stationId = station.routeStation.samId;

    // Prüfen ob Kamera-Dialog bereits offen ist
    if (this.openDialogs.has(stationId)) {
      return;
    }

    // Station als "in Verwendung" markieren
    this.openDialogs.add(stationId);

    const dialogRef = this.dialog.open(CameraViewModalComponent, {
      data: {
        name: station.routeStation.name,
        rs: station.routeStation.id,
        type: (station.schemaInfo?.cameras && station.schemaInfo.cameras.length > 0 && station.schemaInfo.cameras[0].camType != null) ? getCameraType(station.schemaInfo.cameras[0].camType) : undefined
      },
      hasBackdrop: false,
      panelClass: 'draggable-resizable-dialog'
    });

    dialogRef.afterClosed().subscribe(result => {
      // Station aus Tracking entfernen
      this.openDialogs.delete(stationId);
    });
  }

  public navigateToRouteStation(station: ProjectRouteStationWithParam) {
    this.projectDataService.updateActiveRouteStation(station.routeStation);
    this.router.navigate(['/project/settings']);
  }

  public navigateToTestarea(station: ProjectRouteStationWithParam) {
    this.projectDataService.updateActiveRouteStation(station.routeStation);
    this.router.navigate(['/project/test-area']);
  }


  public updateSolardata(station: ProjectRouteStationWithParam) {
    this.deviceService.refreshDataFromChannels(station.routeStation.id).subscribe(data => this.alertService.alert("Solar Daten werden aktualisiert", AlertTypes.info));
  }

  public findFreeId(array: ProjectRouteStationWithParam[]) {
    const sortedArray = array
      .slice() // Make a copy of the array.
      .sort(function (a, b) { return a.routeStation.z - b.routeStation.z }); // Sort it.
    let previousId = 0;
    for (let element of sortedArray) {
      if (element.routeStation.z != (previousId + 1)) {
        // Found a gap.
        return previousId + 1;
      }
      previousId = element.routeStation.z;
    }
    // Found no gaps.
    return previousId + 1;
  }

  public canBeSwapped(station: ProjectRouteStationWithParam, area: SchemaLineWithPosition): boolean {
    let canBeSwapped = false;
    if (area.station!.length > 0) {
      let highestZ = Math.max(...area.station!.map(x => x.routeStation.z!));
      if (station.routeStation.z === highestZ) {
        canBeSwapped = false;
      }
      else canBeSwapped = true;
    }
    return canBeSwapped
  }

  public onDropStation(event: CdkDragDrop<any>): void {

    if (event.previousContainer.data.station) {
      let station = event.previousContainer.data.station[event.previousIndex];
      station.routeStation.y = +event.container.id;
      station.routeStation.x = event.container.data.x;

      let x = station.routeStation.x
      let y = station.routeStation.y

      if (y === 1) {
        let coordinate = this.line.areaA.find(areaA => areaA.x === x)
        let stations = coordinate?.station
        if (stations?.length === 0 || stations === undefined) { /* hier wird z dann richtig gesetzt */
          station.routeStation.z = 1
        }
        else {
          let gap = this.findFreeId(stations!)
          if (gap === 0) {
            station.routeStation.z = stations.length + 1
          }
          else {
            station.routeStation.z = gap
          }
        }
      }
      if (y === 2) {
        let coordinate = this.line.areaB.find(areaB => areaB.x === x)
        let stations = coordinate?.station
        if (stations?.length === 0 || stations === undefined) {
          station.routeStation.z = 1
        }
        else {
          let gap = this.findFreeId(stations!)
          if (gap === 0) {
            station.routeStation.z = stations.length + 1
          }
          else {
            station.routeStation.z = gap
          }
        }
      }
      this.stationService.editProjectRouteStation(station.routeStation.id, station.routeStation).subscribe(() => {
        this.projectDataService.updateActiveGroup(this.activeGroup);
      });
    }
  }

  onRadarLaneBClicked(area: any) {
    this.isRadarDialogOpenForX = area.x;
    this.openRadarDataChart()
  }

  onRadarLaneAClicked(area: any) {
    this.isRadarDialogOpenForX = area.x;
    this.openRadarDataChart()
  }

  private openRadarDataChart(): void {
    let x = this.isRadarDialogOpenForX;
    if (x < 1)
      return;

    var targetsRadare = this.determineRadarData(x);

    if (targetsRadare !== undefined && targetsRadare!.length > 0) {
      this.radarData$.next(targetsRadare);

      this.dialog.open(RadarDataChartComponent, {
        data: { radar$: this.radarData$.asObservable()},
        width: '98vw'
      }).afterClosed().subscribe(result => {
          this.isRadarDialogOpenForX = 0;});
    }
  }
  private determineRadarData(x: number): Radar[] {
    let radars : Radar[] = [];
    let activeGroupId = this.activeGroup?.id;
    var routeStationsWithRadars = this.projectRouteStations?.filter(element => element.routeStation.x === x && element.routeStation.groupId === activeGroupId && (element.routeStation.y == 1 || (element.routeStation.y == 2)))
    if (!routeStationsWithRadars || routeStationsWithRadars.length == 0) 
      return radars;

    routeStationsWithRadars?.forEach(targetObj => {
      radars = radars.concat((targetObj?.schemaInfo?.radars ?? [])
        .filter(r => r.data != null)
        .map(r => mapSchemaRadarToChartRadar(r)));
    })
    radars.sort((a, b) => a.de - b.de) // to get an order from de 1 to 3
    return radars;
  }

  public onExpandSchemeClicked(): void {
    for (let area of this.line.areaA) {
      area.isActive = true;
    }
    for (let area of this.line.areaB) {
      area.isActive = true;
    }
  }

  public onCollapseSchemeClicked(): void {
    this.startTimer()
    if (!this.projectRouteStations) {
      return;
    }
    if (this.projectRouteStations.length === 0) {
      for (let area of this.line.areaA) {
        area.isActive = false;
      }
      for (let area of this.line.areaB) {
        area.isActive = false;
      }
      return;
    }
    let stationsA: ProjectRouteStationWithParam[] = [];
    let stationsB: ProjectRouteStationWithParam[] = [];
    for (let station of this.projectRouteStations) {
      if (station.routeStation.y === 1) {
        stationsA.push(station);
      } else if (station.routeStation.y === 2) {
        stationsB.push(station);
      }
    }

    let stations = this.projectRouteStations.sort(
      (a, b) => b.routeStation.x - a.routeStation.x);
    for (let area of this.line.areaA) {
      if (stationsA[0]) {
        if (area.x > stations[0].routeStation.x) {
          area.isActive = false;
        }
      } else {
        area.isActive = false;
      }
    }
    for (let area of this.line.areaB) {
      if (stationsB[0]) {
        if (area.x > stations[0].routeStation.x) {
          area.isActive = false;
        }
      } else {
        area.isActive = false;
      }
    }
  }

  private stopTimer() {
    if (this.timer)
      clearInterval(this.timer)
  }

  private startTimer() {
    this.stopTimer();
    this.timer = setInterval(() => {
      this.countdown--;

      if (this.countdown <= 0) {
        if (this.activeGroup) {
          this.projectDataService.updateActiveGroup(this.activeGroup);
          if (this.isRouteStationDialogOpen)
            this.countdown = 5;
          else if (this.groupHasCamera)
            this.countdown = 15;
          else
            this.countdown = 30;
        }
      }
    }, 1000);
  }

  private fillLineWithStations(routeStations: ProjectRouteStationWithParam[]): void {
    if (!this.isGroupChanged) {
      this.line = new SchemaLine(
        [{ station: undefined, x: 1, isActive: this.line.areaA[0].isActive, line: [], colorArr: [] }, { station: undefined, x: 2, isActive: this.line.areaA[1].isActive, line: [], colorArr: [] },
        { station: undefined, x: 3, isActive: this.line.areaA[2].isActive, line: [], colorArr: [] }, { station: undefined, x: 4, isActive: this.line.areaA[3].isActive, line: [], colorArr: [] },
        { station: undefined, x: 5, isActive: this.line.areaA[4].isActive, line: [], colorArr: [] }, { station: undefined, x: 6, isActive: this.line.areaA[5].isActive, line: [], colorArr: [] },
        { station: undefined, x: 7, isActive: this.line.areaA[6].isActive, line: [], colorArr: [] }, { station: undefined, x: 8, isActive: this.line.areaA[7].isActive, line: [], colorArr: [] },
        { station: undefined, x: 9, isActive: this.line.areaA[8].isActive, line: [], colorArr: [] }, { station: undefined, x: 10, isActive: this.line.areaA[9].isActive, line: [], colorArr: [] },
        { station: undefined, x: 11, isActive: this.line.areaA[10].isActive, line: [], colorArr: [] }, { station: undefined, x: 12, isActive: this.line.areaA[11].isActive, line: [], colorArr: [] },
        { station: undefined, x: 13, isActive: this.line.areaA[12].isActive, line: [], colorArr: [] }, { station: undefined, x: 14, isActive: this.line.areaA[13].isActive, line: [], colorArr: [] },
        { station: undefined, x: 15, isActive: this.line.areaA[14].isActive, line: [], colorArr: [] }, { station: undefined, x: 16, isActive: this.line.areaA[15].isActive, line: [], colorArr: [] },
        { station: undefined, x: 17, isActive: this.line.areaA[16].isActive, line: [], colorArr: [] }, { station: undefined, x: 18, isActive: this.line.areaA[17].isActive, line: [], colorArr: [] },
        { station: undefined, x: 19, isActive: this.line.areaA[18].isActive, line: [], colorArr: [] }, { station: undefined, x: 20, isActive: this.line.areaA[19].isActive, line: [], colorArr: [] },
        { station: undefined, x: 21, isActive: this.line.areaA[20].isActive, line: [], colorArr: [] }, { station: undefined, x: 22, isActive: this.line.areaA[21].isActive, line: [], colorArr: [] },
        { station: undefined, x: 23, isActive: this.line.areaA[22].isActive, line: [], colorArr: [] }, { station: undefined, x: 24, isActive: this.line.areaA[23].isActive, line: [], colorArr: [] },
        { station: undefined, x: 25, isActive: this.line.areaA[24].isActive, line: [], colorArr: [] }],
        [{ station: undefined, x: 1, isActive: this.line.areaB[0].isActive, line: [], colorArr: [] }, { station: undefined, x: 2, isActive: this.line.areaB[1].isActive, line: [], colorArr: [] },
        { station: undefined, x: 3, isActive: this.line.areaB[2].isActive, line: [], colorArr: [] }, { station: undefined, x: 4, isActive: this.line.areaB[3].isActive, line: [], colorArr: [] },
        { station: undefined, x: 5, isActive: this.line.areaB[4].isActive, line: [], colorArr: [] }, { station: undefined, x: 6, isActive: this.line.areaB[5].isActive, line: [], colorArr: [] },
        { station: undefined, x: 7, isActive: this.line.areaB[6].isActive, line: [], colorArr: [] }, { station: undefined, x: 8, isActive: this.line.areaB[7].isActive, line: [], colorArr: [] },
        { station: undefined, x: 9, isActive: this.line.areaB[8].isActive, line: [], colorArr: [] }, { station: undefined, x: 10, isActive: this.line.areaB[9].isActive, line: [], colorArr: [] },
        { station: undefined, x: 11, isActive: this.line.areaB[10].isActive, line: [], colorArr: [] }, { station: undefined, x: 12, isActive: this.line.areaB[11].isActive, line: [], colorArr: [] },
        { station: undefined, x: 13, isActive: this.line.areaB[12].isActive, line: [], colorArr: [] }, { station: undefined, x: 14, isActive: this.line.areaB[13].isActive, line: [], colorArr: [] },
        { station: undefined, x: 15, isActive: this.line.areaB[14].isActive, line: [], colorArr: [] }, { station: undefined, x: 16, isActive: this.line.areaB[15].isActive, line: [], colorArr: [] },
        { station: undefined, x: 17, isActive: this.line.areaB[16].isActive, line: [], colorArr: [] }, { station: undefined, x: 18, isActive: this.line.areaB[17].isActive, line: [], colorArr: [] },
        { station: undefined, x: 19, isActive: this.line.areaB[18].isActive, line: [], colorArr: [] }, { station: undefined, x: 20, isActive: this.line.areaB[19].isActive, line: [], colorArr: [] },
        { station: undefined, x: 21, isActive: this.line.areaB[20].isActive, line: [], colorArr: [] }, { station: undefined, x: 22, isActive: this.line.areaB[21].isActive, line: [], colorArr: [] },
        { station: undefined, x: 23, isActive: this.line.areaB[22].isActive, line: [], colorArr: [] }, { station: undefined, x: 24, isActive: this.line.areaB[23].isActive, line: [], colorArr: [] },
        { station: undefined, x: 25, isActive: this.line.areaB[24].isActive, line: [], colorArr: [] }]);
    } else {
      this.line = new SchemaLine(
        [{ station: undefined, x: 1, isActive: false, line: [], colorArr: [] }, { station: undefined, x: 2, isActive: false, line: [], colorArr: [] }, { station: undefined, x: 3, isActive: false, line: [], colorArr: [] },
        { station: undefined, x: 4, isActive: false, line: [], colorArr: [] }, { station: undefined, x: 5, isActive: false, line: [], colorArr: [] }, { station: undefined, x: 6, isActive: false, line: [], colorArr: [] },
        { station: undefined, x: 7, isActive: false, line: [], colorArr: [] }, { station: undefined, x: 8, isActive: false, line: [], colorArr: [] }, { station: undefined, x: 9, isActive: false, line: [], colorArr: [] },
        { station: undefined, x: 10, isActive: false, line: [], colorArr: [] }, { station: undefined, x: 11, isActive: false, line: [], colorArr: [] }, { station: undefined, x: 12, isActive: false, line: [], colorArr: [] },
        { station: undefined, x: 13, isActive: false, line: [], colorArr: [] }, { station: undefined, x: 14, isActive: false, line: [], colorArr: [] }, { station: undefined, x: 15, isActive: false, line: [], colorArr: [] },
        { station: undefined, x: 16, isActive: false, line: [], colorArr: [] }, { station: undefined, x: 17, isActive: false, line: [], colorArr: [] }, { station: undefined, x: 18, isActive: false, line: [], colorArr: [] },
        { station: undefined, x: 19, isActive: false, line: [], colorArr: [] }, { station: undefined, x: 20, isActive: false, line: [], colorArr: [] }, { station: undefined, x: 21, isActive: false, line: [], colorArr: [] },
        { station: undefined, x: 22, isActive: false, line: [], colorArr: [] }, { station: undefined, x: 23, isActive: false, line: [], colorArr: [] }, { station: undefined, x: 24, isActive: false, line: [], colorArr: [] },
        { station: undefined, x: 25, isActive: false, line: [], colorArr: [] },
      ],
        [{ station: undefined, x: 1, isActive: false, line: [], colorArr: [] }, { station: undefined, x: 2, isActive: false, line: [], colorArr: [] }, { station: undefined, x: 3, isActive: false, line: [], colorArr: [] },
        { station: undefined, x: 4, isActive: false, line: [], colorArr: [] }, { station: undefined, x: 5, isActive: false, line: [], colorArr: [] }, { station: undefined, x: 6, isActive: false, line: [], colorArr: [] },
        { station: undefined, x: 7, isActive: false, line: [], colorArr: [] }, { station: undefined, x: 8, isActive: false, line: [], colorArr: [] }, { station: undefined, x: 9, isActive: false, line: [], colorArr: [] },
        { station: undefined, x: 10, isActive: false, line: [], colorArr: [] }, { station: undefined, x: 11, isActive: false, line: [], colorArr: [] }, { station: undefined, x: 12, isActive: false, line: [], colorArr: [] },
        { station: undefined, x: 13, isActive: false, line: [], colorArr: [] }, { station: undefined, x: 14, isActive: false, line: [], colorArr: [] }, { station: undefined, x: 15, isActive: false, line: [], colorArr: [] },
        { station: undefined, x: 16, isActive: false, line: [], colorArr: [] }, { station: undefined, x: 17, isActive: false, line: [], colorArr: [] }, { station: undefined, x: 18, isActive: false, line: [], colorArr: [] },
        { station: undefined, x: 19, isActive: false, line: [], colorArr: [] }, { station: undefined, x: 20, isActive: false, line: [], colorArr: [] }, { station: undefined, x: 21, isActive: false, line: [], colorArr: [] },
        { station: undefined, x: 22, isActive: false, line: [], colorArr: [] }, { station: undefined, x: 23, isActive: false, line: [], colorArr: [] }, { station: undefined, x: 24, isActive: false, line: [], colorArr: [] },
        { station: undefined, x: 25, isActive: false, line: [], colorArr: [] }
      ]);
      this.isGroupChanged = false;
    }

    this.unassignedStations = [];
    this.setLinesOver6(routeStations);
    this.sortMetainformationIntoSchema(routeStations);
    this.calculateTrafficSignPosition();
    let widthA: number[] = [150, 150, 150, 150, 150, 150, 150, 150, 150, 150, 150, 150, 150, 150, 150, 150, 150, 150, 150, 150, 150, 150, 150, 150, 150];
    let widthB: number[] = [150, 150, 150, 150, 150, 150, 150, 150, 150, 150, 150, 150, 150, 150, 150, 150, 150, 150, 150, 150, 150, 150, 150, 150, 150];
    for (let station of routeStations) {
      if (station.routeStation.y === 1) {
        if (station.routeStation.x > 0 && station.routeStation.x < this.line.areaA.length+1 && station.routeStation.x < widthA.length+1) {
          if (this.line.areaA[station.routeStation.x - 1].station) {
            this.line.areaA[station.routeStation.x - 1].station?.push(station);
            widthA[station.routeStation.x - 1] += 300;
          } else {
            this.line.areaA[station.routeStation.x - 1].station = [station];
            widthA[station.routeStation.x - 1] = 300;
          }
        } else {
          this.unassignedStations.push(station);
        }
      } else if (station.routeStation.y === 2) {
        if (station.routeStation.x > 0 && station.routeStation.x < this.line.areaB.length+1 && station.routeStation.x < widthB.length+1) {
          if (this.line.areaB[station.routeStation.x - 1].station) {
            this.line.areaB[station.routeStation.x - 1].station?.push(station);
            widthB[station.routeStation.x - 1] += 300;
          } else {
            this.line.areaB[station.routeStation.x - 1].station = [station];
            widthB[station.routeStation.x - 1] = 300;
          }
        } else {
          this.unassignedStations.push(station);
        }
      } else {
        this.unassignedStations.push(station);
      }
    }
    for (let index = 0; index < this.width.length && index < widthA.length && index < widthB.length; index++) {
      this.width[index] = widthA[index] > widthB[index] ? widthA[index] : widthB[index];
    }
    this.isCompletelyLoaded = true;

    this.line.areaA.forEach(element => {
      element.station = _.orderBy(element.station, ['routeStation.z'], ['asc'])
    });
    this.line.areaB.forEach(element => {
      element.station = _.orderBy(element.station, ['routeStation.z'], ['asc'])
    });
    this.colorRoadByZ(routeStations)  // do coloring late in order to not overwrite with standards
  }

  private setLinesOver6(routeStations: ProjectRouteStationWithParam[]): void {
    let stationsA: ProjectRouteStationWithParam[] = [];
    let stationsB: ProjectRouteStationWithParam[] = [];

    for (let station of routeStations) {
      if (station.routeStation.y === 1) {
        stationsA.push(station);
      } else if (station.routeStation.y === 2) {
        stationsB.push(station);
      }
    }
    let stations = routeStations.sort(
      (a, b) => b.routeStation.x - a.routeStation.x);
    if (!stations[0]) { return; }
    if (stationsA[0]) {

      for (let area of this.line.areaA) {
        if (area.x <= stations[0].routeStation.x) {
          area.isActive = true;
        }
      }
    }
    if (stationsB[0]) {
      for (let area of this.line.areaB) {
        if (area.x <= stations[0].routeStation.x) {
          area.isActive = true;
        }
      }
    }
  }

  public changeZWithRightNeighbour(station: ProjectRouteStationWithParam): void {
    let oldZ = station.routeStation.z;
    let newZ = station.routeStation.z - 1

    station.routeStation.z = station.routeStation.z + 1;
    this.stationService.editProjectRouteStation(station.routeStation.id, station.routeStation).subscribe(() => {
      this.projectDataService.updateActiveGroup(this.activeGroup);
    });
    if (station.routeStation.y === 1) {
      let area = this.line.areaA.find(x => x.x === station.routeStation.x);
      if (area) {
        let foundStation = area.station?.find(x => x.routeStation.z === station.routeStation.z && x.routeStation.samId !== station.routeStation.samId);

        if (foundStation) { foundStation.routeStation.z = oldZ }

        this.stationService.editProjectRouteStation(foundStation!.routeStation.id, foundStation?.routeStation!).subscribe(() => {
          this.projectDataService.updateActiveGroup(this.activeGroup);
        });
      }
    }
    if (station.routeStation.y === 2) {
      let area = this.line.areaB.find(x => x.x === station.routeStation.x);
      if (area) {
        let foundStation = area.station?.find(x => x.routeStation.z === station.routeStation.z && x.routeStation.samId !== station.routeStation.samId);
        if (foundStation) { foundStation.routeStation.z = oldZ }
        this.stationService.editProjectRouteStation(foundStation!.routeStation.id, foundStation?.routeStation!).subscribe(() => {
          this.projectDataService.updateActiveGroup(this.activeGroup);
        });
      }
    }
  }

  public sortMetainformationIntoSchema(routeStations: ProjectRouteStationWithParam[]) {
    let stations = routeStations.sort(
      (a, b) => b.routeStation.x - a.routeStation.x);
    let collectionMeta: number[] = [];
    if (this.activeGroup?.metaInformation === undefined || this.activeGroup?.metaInformation === null) return;
    this.activeGroup?.metaInformation!.forEach(mi => collectionMeta.push(mi.x))
    let highestMetainfoX = Math.max(...collectionMeta);

    const isAreaCollapsed = (element: boolean) => element === false;
    const isAreaAEmpty = (element: number) => element !== 1;
    const isAreaBEmpty = (element: number) => element !== 2;

    let areaAisEmpty = this.activeGroup?.metaInformation.map((x: ProjectGroupMetaInformation) => x.y).every(isAreaAEmpty) && stations.map((x: ProjectRouteStationWithParam) => x.routeStation.y).every(isAreaAEmpty) /*hier noch den abgleich? */; /* dann größtes (gegenüberliegendes?) x prüfen, und iterieren und alle unter dem größter auf isActive = true setzen */
    let areaBisEmpty = this.activeGroup?.metaInformation.map((x: ProjectGroupMetaInformation) => x.y).every(isAreaBEmpty) && stations.map((x: ProjectRouteStationWithParam) => x.routeStation.y).every(isAreaBEmpty);

    let areaAisCollapsed = this.line.areaA.map(x => x.isActive).every(isAreaCollapsed);
    let areaBisCollapsed = this.line.areaB.map(x => x.isActive).every(isAreaCollapsed);
    if (areaAisCollapsed && areaBisCollapsed) return;
    if (!areaBisEmpty) {
      for (let area of this.line.areaB) {
        if (area.x <= highestMetainfoX) {
          area.isActive = true;
        }
      }
    }
    if (!areaAisEmpty) {
      for (let area of this.line.areaA) {
        if (area.x <= highestMetainfoX) {
          area.isActive = true;
        }
      }
    }
  }

  private setTrafficLanesFromActiveGroup(group: ProjectGroup): void {
    this.freewayLanes = [];
    for (let index = group.trafficLanes; index > 0; index--) {
      this.freewayLanes.push({ id: index });
    }
  }

  private deleteStationFromSchema(station: ProjectRouteStationWithParam): void {
    if (!this.projectRouteStations) { return }
    let editStation = this.projectRouteStations.find(s => s === station);
    if (editStation) {
      editStation.routeStation.x = 0;
      editStation.routeStation.y = 0;
      this.stationService.editProjectRouteStation(editStation.routeStation.id, editStation.routeStation).subscribe(() => {
        this.projectDataService.updateActiveGroup(this.activeGroup);
      });
    }
  }

  private calculateTrafficSignPosition(): void {
    this.isAreaACollapsed = true;
    this.projectRouteStations?.forEach(routeStations => { if (routeStations.routeStation.y === 1) { this.isAreaACollapsed = false }; if (routeStations.routeStation.y === 2) { this.isAreaBCollapsed = false } })
    this.activeGroup?.metaInformation?.forEach(metaInformation => { if (metaInformation.y === 1) { this.isAreaACollapsed = false }; if (metaInformation.y === 2) { this.isAreaBCollapsed = false } })
    if (this.isAreaACollapsed && this.isAreaBCollapsed) {
      this.trafficSignPosition = -12
      return
    }
    if (this.isAreaACollapsed) {
      this.trafficSignPosition = 10 + (33 * this.freewayLanes.length / 2) - 13;
    }
    else {
      this.trafficSignPosition = (36 + (33 * this.freewayLanes.length / 2) - 13) * (-1);
    }
  }

  public getWarnLevelIcon(warnLevel: number): string {
    switch (warnLevel) {
      case 1:
        return 'assets/icons/info.svg';
      case 2:
        return 'assets/icons/warning.svg';
      case 3:
        return 'assets/icons/error.svg';
      default:
        return '';
    }
  }
}
